import {HttpServices} from "../Helpers";

export const GetAllSetupsJobRequisition = async ({
  limit,
  page,
  search,
  status = true,
  use_for = "dropdown",
  account_uuid,
  with_than,
  other_than,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (status) queryList.push(`status=${status}`);
  if (account_uuid) queryList.push(`account_uuid=${account_uuid}`);
  if (use_for) queryList.push(`use_for=${use_for}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/requisition/${
      process.env.REACT_APP_VERSION_API
    }/request?${queryList.join("&")}`,
    {
      params: {with_than, other_than},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetAllSetupsJobRequisitionCompanies = async ({uuid}) => {
  const queryList = [];
  if (uuid) queryList.push(`uuid=${uuid}`);
  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/requisition/${
      process.env.REACT_APP_VERSION_API
    }/request/user_company?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetAllJobRequisitionVacancies = async ({
  limit,
  page,
  search,
  status = true,
  use_for = "dropdown",
  account_uuid,
  with_than,
  other_than,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (status) queryList.push(`status=${status}`);
  if (account_uuid) queryList.push(`account_uuid=${account_uuid}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  if (with_than) queryList.push(`with_than=${with_than}`);
  if (other_than) queryList.push(`other_than=${other_than}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/requisition/${
      process.env.REACT_APP_VERSION_API
    }/request?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetAllReportVacancies = async ({
  limit,
  page,
  search,
  status = true,
  use_for = "dropdown",
  account_uuid,
  with_than,
  other_than,
  requested,
  filters,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (status) queryList.push(`status=${status}`);
  if (account_uuid) queryList.push(`account_uuid=${account_uuid}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  if (with_than) queryList.push(`with_than=${with_than}`);
  if (other_than) queryList.push(`other_than=${other_than}`);
  if (requested !== undefined && requested !== null) queryList.push(`requested=${requested}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/vacant/${
      process.env.REACT_APP_VERSION_API
    }/report?${queryList.join("&")}`,
    {
      params: filters,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const getSetupsJobRequisitionById = async ({uuid}) => {
  const queryList = [];
  if (uuid) queryList.push(`uuid=${uuid}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/requisition/${
      process.env.REACT_APP_VERSION_API
    }/request/view?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetVacanciesIsAllowedRequest = async ({vacant_uuid}) => {
  const queryList = [];

  const result = await HttpServices.post(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/requisition/${
      process.env.REACT_APP_VERSION_API
    }/request/valid?${queryList.join("&")}`,
    {
      vacant_uuid,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const CreateSetupsJobRequisition = async (body) => {
  const result = await HttpServices.post(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/requisition/${process.env.REACT_APP_VERSION_API}/request`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const DeleteSetupsJobRequisition = async (params) => {
  const result = await HttpServices.delete(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/requisition/${process.env.REACT_APP_VERSION_API}/request`,
    {
      params,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
export const GetJobRequisitionSettings = async () => {
  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/requisition/${process.env.REACT_APP_VERSION_API}/setting`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const CancelJobRequisition = async (params) => {
  const result = await HttpServices.delete(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/vacant/${process.env.REACT_APP_VERSION_API}/report`,
    {
      params,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const ModifyVacancyRequest = async (body) => {
  const result = await HttpServices.post(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/${process.env.REACT_APP_VERSION_API}/service/change/request`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetVacantMatchingList = async ({
  limit,
  page,
  use_for = "list",
  vacant_uuid,
  branch_config_uuid,
  transcation_type,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (use_for) queryList.push(`use_for=${use_for}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/vacant/${
      process.env.REACT_APP_VERSION_API
    }/matching?${queryList.join("&")}`,
    {
      params: {vacant_uuid, branch_config_uuid, transcation_type},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const CreateBulkAction = async ({
  action_type,
  requested_uuids,
  payload,
}) => {
  const result = await HttpServices.post(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/requisition/${process.env.REACT_APP_VERSION_API}/bulk-action`,
    {action_type, requested_uuids, payload}
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetBulkActionList = async ({action_type, limit, page}) => {
  const queryList = [];
  if (action_type) queryList.push(`action_type=${action_type}`);
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/requisition/${
      process.env.REACT_APP_VERSION_API
    }/bulk-action?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetBulkActionDetails = async ({
  bulk_operation_uuid,
  limit,
  page,
}) => {
  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/requisition/${process.env.REACT_APP_VERSION_API}/bulk-action/show`,
    {
      params: {bulk_operation_uuid, page, limit},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const ConfirmBulkAction = async ({bulk_operation_uuid}) => {
  const result = await HttpServices.post(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/requisition/${process.env.REACT_APP_VERSION_API}/bulk-action/confirm`,
    {bulk_operation_uuid}
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetAllModifiedVacancies = async ({
  limit,
  page,
  search,
  status = true,
  use_for = "dropdown",
  account_uuid,
  with_than,
  other_than,
  filters,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (status) queryList.push(`status=${status}`);
  if (account_uuid) queryList.push(`account_uuid=${account_uuid}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  if (with_than) queryList.push(`with_than=${with_than}`);
  if (other_than) queryList.push(`other_than=${other_than}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/${
      process.env.REACT_APP_VERSION_API
    }/service/change/request/list?${queryList.join("&")}`,
    {
      params: filters,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
